const ro = {
    common: {
        history: "versiune istorică"
    }
};
export default ro;



// WEBPACK FOOTER //
// ./src/i18n/langs/ro.js